// Uygulama geneli özellik bayrakları.
// Oyuncu profili ve sosyal özellikler (kendi profili + /u/:username) hâlâ
// geliştiriliyor. Kullanıcıya kapalı tutuyoruz; hazır olunca .env dosyasında
// REACT_APP_SOCIAL_ENABLED=true yapıp yeniden build + deploy yeterli.
export const SOCIAL_ENABLED = process.env.REACT_APP_SOCIAL_ENABLED === 'true';
